import React, { useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Box,
  Button,
  TextField,
} from '@material-ui/core';
import moment from 'moment';
import 'moment-timezone';

import ClockIcon from "../images/clock-icon.svg"
import socketio from "socket.io-client";

import APIS, {glb_url, basicAuth} from "../utils/APIS"

import { allQuestions } from "./Home.js"


const colors = {
  "toDo" : "rgba(255, 0, 0, 0.7)",
  "inProgress" : "orange",
  "ready" : "#46c742",
}

const Dashboard = () => {
  const navigate = useNavigate();

  const [mode, setMode] = useState(["toDo", "inProgress", "ready"])

  const changeMode = (newMode) => {
    if (mode?.includes(newMode)) {
      //on enlève
      let newArr = [...mode].filter((el) => el !== newMode)
      setMode(newArr)
    } else {
      let newArr = [...mode]
      newArr.push(newMode)
      setMode(newArr)
    }
    /*if (mode === newMode) {
      setMode("all")
    } else {
      setMode(newMode)
    }*/
  }

  const [socket, setSocket] = useState(null)
  const renewSocket = () => {
    if (socket) {
      socket.disconnect().connect()
    }
  }
  useEffect(() => {
    if (socket) {
      const connectedEvent = data => {
        console.log("sio properly connected")
      }

      const updateOrdersEvent = data => {
        console.log("updateOrdersFromSocketIO")
        updateOrders()
      }

      socket.on("connectedCustom", connectedEvent)
      socket.on("updateOrders", updateOrdersEvent)

      return () => {
        socket.off("connectedCustom", connectedEvent)
        socket.off("updateOrders", updateOrdersEvent)
      }
    }
  }, [socket])

  useEffect(() => {
    setSocket(
      socketio.connect(glb_url, {
        query: {
          token: basicAuth
        }
      })
    )
  }, [])
  /* END SOCKET */

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      let rootElemFirstChild = document.getElementById("root").firstChild
      if (rootElemFirstChild) {
        let scaleWidth = window.innerWidth / 2560
        let scaleHeight = window.innerHeight / 1600
        if (scaleWidth >= 1 && scaleHeight >=1) {
          rootElemFirstChild.style.transform = "scale(1)"
        } else {
          let scale = Math.min(scaleWidth, scaleHeight)
          rootElemFirstChild.style.transform = "scale("+scale+")"
        }
        rootElemFirstChild.style.transformOrigin = "top left"
      }
    }
    // Add event listener
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const [orders, setOrders] = useState([])
  const [stats, setStats] = useState({
    toDo : "-",
    inProgress : "-",
    ready : "-"
  })
  const [filteredOrders, setFilteredOrders] = useState([])
  const updateOrders = () => {
    APIS.getAllOrders().then((result) => {
      if (result?.message === "allOrders" && result?.orders) {
        setOrders(result?.orders)
      } else {
        alert("Une erreur est survenue")
      }
    })
  }

  useEffect(() => {
    //stats
    setStats({
      toDo : orders?.filter((el) => el.status === "toDo")?.length || 0,
      inProgress : orders?.filter((el) => el.status === "inProgress")?.length || 0,
      ready : orders?.filter((el) => el.status === "ready")?.length || 0,
    })
    //filtered by mode
    if (mode?.length === 3) {
      setFilteredOrders(orders.slice(0, 100)) //on limite ici à 100 pour l'affichage en mode "all"
    } else {
      setFilteredOrders(orders?.filter((el) => mode?.includes(el.status)))
    }
  }, [orders, mode])

  useEffect(() => {
    updateOrders()
  }, [])

  return (
    <>
      <Helmet>
        <title>Dashboard | Gemini Bar</title>
      </Helmet>

      <Box sx={{
        width:"2560px",
        height:"1600px",
        backgroundColor:"background.paper",
        padding:"30px",
        overflow:"hidden",
      }}>

        {/* HEADER */}
        <Box sx={{
          width:"100%",
          display:"flex",
          height:"170px",
          gap:"40px"
        }}>
          <Box onClick={() => { changeMode("toDo") }} sx={{
            borderRadius:"24px",
            background:colors.toDo,
            border:mode?.includes("toDo") ? "4px solid black" : "4px solid transparent",
            paddingLeft:"40px",
            paddingTop:"10px",
            flex:1,
            flexShrink:0,
            lineHeight:"70px",
            opacity:mode?.includes("toDo") ? 1 : 0.5,
          }}>
            <Box sx={{fontSize:"60px", fontWeight:"bold"}}>
              {stats?.toDo}
            </Box>
            <Box sx={{fontSize:"40px"}}>En attente</Box>
          </Box>
          <Box onClick={() => { changeMode("inProgress") }} sx={{
            borderRadius:"24px",
            background:colors.inProgress,
            border:mode?.includes("inProgress") ? "4px solid black" : "4px solid transparent",
            flex:1,
            flexShrink:0,
            lineHeight:"70px",
            paddingLeft:"40px",
            paddingTop:"10px",
            opacity:mode?.includes("inProgress") ? 1 : 0.5,
          }}>
            <Box sx={{fontSize:"60px", fontWeight:"bold"}}>
              {stats?.inProgress}
            </Box>
            <Box sx={{fontSize:"40px"}}>En préparation</Box>
          </Box>
          <Box onClick={() => { changeMode("ready") }} sx={{
            borderRadius:"24px",
            background:colors.ready,
            border:mode?.includes("ready") ? "4px solid black" : "4px solid transparent",
            flex:1,
            flexShrink:0,
            lineHeight:"70px",
            paddingLeft:"40px",
            paddingTop:"10px",
            opacity:mode?.includes("ready") ? 1 : 0.5,
          }}>
            <Box sx={{fontSize:"60px", fontWeight:"bold"}}>
              {stats?.ready}
            </Box>
            <Box sx={{fontSize:"40px"}}>Prêtes</Box>
          </Box>
        </Box>

        {/* LISTS */}
        <Box sx={{marginTop:"50px", overflow:"scroll", maxHeight:"calc(100% - 230px)", scrollbarWidth:"none",}}>
          <Box sx={{
            display:"flex",
            flexWrap:"wrap",
            gap:"30px",
          }}>
            {filteredOrders?.map((elem, index) => {
              let disabledButton = false
              let borderColor = ""
              if (colors[elem?.status]) {
                borderColor = colors[elem?.status]
              }

              let bases = allQuestions?.step5?.questions
              bases = bases.filter((el) => el.view === true)
              //console.log(bases)

              let reps = JSON.parse(elem?.reps)
              let base = ""
              let creme = ""
              let boost = ""
              if (reps) {
                //base = allQuestions?.step5?.questions[reps?.q5]?.title
                base = bases[reps?.q5]?.title
                creme = allQuestions?.step6?.questions[reps?.q6]?.baristaTitle
                boost = allQuestions?.step4?.questions[reps?.q4]?.baristaTitle
              }

              return (
                <Box key={index} sx={{
                  flexBasis:'calc(33% - 12px)',
                  flexShrink:0,
                  height:"500px",
                  background:"white",
                  borderRadius:"32px",
                  borderTop: "4px solid "+borderColor,
                  borderBottom: "4px solid "+borderColor,
                  borderLeft: "12px solid "+borderColor,
                  borderRight: "12px solid "+borderColor,
                  boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)",
                  padding:"20px",
                  display:"flex",
                  flexDirection:"column",
                  justifyContent:"space-between"
                }}>
                  <Box sx={{display:"flex", justifyContent:"space-between"}}>
                    <Box sx={{fontSize:"30px"}}>#GB-{elem?.id?.toString().padStart(5, "0")}</Box>
                    <Box sx={{fontSize:"35px", fontWeight:600, padding:"10px 25px", borderRadius:"50px", background:"#174EA6", color:"white"}}>
                      {elem?.smoothieName}
                    </Box>
                  </Box>
                  <Box sx={{fontSize:"35px", fontWeight:600}}>
                    Base : {base}<br/>
                    Crème : {creme}<br/>
                    Boost : {boost}
                  </Box>
                  <Box>
                    <Box sx={{ fontWeight:"bold", fontSize:"40px", marginBottom:"5px", textTransform:"capitalize" }}>
                      {elem?.name}
                    </Box>
                    <Box sx={{ fontSize:"35px", color:"#564334", display:"flex", alignItems:"center" }}>
                      <img src={ClockIcon} style={{width:"35px", marginRight:"10px"}}/>
                      {moment(elem?.createdAt).tz('Europe/Saratov').format("HH:mm")}
                      {` • `}
                      {moment(elem?.createdAt).tz('Europe/Saratov').format("DD/MM/YYYY")}
                    </Box>
                  </Box>
                  <Box sx={{height:"80px"}}>
                    {elem?.status === "toDo" &&
                      <Button
                        variant="contained"
                        onClick={() => {
                          APIS.updateOrder({id : elem?.id, status:"inProgress"}).then((result) => {
                            let newArr = [...filteredOrders]
                            let newElem = newArr.find((el) => el.id === elem?.id)
                            if (newElem) {
                              newElem.status = "inProgress"
                            }
                            setFilteredOrders(newArr)
                            if (result?.message !== "updateOrder") {
                              console.log("erreur updateOrder")
                              alert("Une erreur est survenue")
                            } else {
                              //console.log("order update ok")
                            }
                          })
                        }}
                        sx={{
                          minHeight:"80px !important",
                          height:"80px !important",
                          borderRadius:"16px !important",
                          fontSize:"40px !important",
                          minWidth:"0px !important",
                          width:"100%",
                          boxShadow:"none !important",
                          background:colors?.toDo,
                          color:"black",
                          "&:hover" : {
                            background:colors?.toDo,
                          }
                        }}
                      >
                        Passer en préparation
                      </Button>
                    }
                    {elem?.status === "inProgress" &&
                      <Button
                        variant="contained"
                        onClick={() => {
                          APIS.updateOrder({id : elem?.id, status:"ready"}).then((result) => {
                            let newArr = [...filteredOrders]
                            let newElem = newArr.find((el) => el.id === elem?.id)
                            if (newElem) {
                              newElem.status = "ready"
                            }
                            setFilteredOrders(newArr)
                            if (result?.message !== "updateOrder") {
                              console.log("erreur updateOrder")
                              alert("Une erreur est survenue")
                            } else {
                              //console.log("order update ok")
                            }
                          })
                        }}
                        sx={{
                          minHeight:"80px !important",
                          height:"80px !important",
                          borderRadius:"16px !important",
                          fontSize:"40px !important",
                          minWidth:"0px !important",
                          width:"100%",
                          boxShadow:"none !important",
                          background:colors?.inProgress,
                          color:"black",
                          "&:hover" : {
                            background:colors?.inProgress,
                          }
                        }}
                      >
                        Passer en prêt
                      </Button>
                    }
                  </Box>
                </Box>
              )
            })}
          </Box>
        </Box>

      </Box>

    </>
  );
};

export default Dashboard;
